import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-upload"
export default class extends Controller {
  connect() {
    this.setupRemoveButtons()
  }

  setupRemoveButtons() {
    // Setup logo remove button
    const logoRemoveBtn = document.getElementById('logo-remove')
    if (logoRemoveBtn) {
      logoRemoveBtn.addEventListener('click', () => {
        this.clearFileInput('logo')
        document.getElementById('logo-preview').classList.add('hidden')
        document.getElementById('logo-dropzone').classList.remove('hidden')
        logoRemoveBtn.classList.add('hidden')
      })
    }

    // Setup logo white remove button
    const logoWhiteRemoveBtn = document.getElementById('logo-white-remove')
    if (logoWhiteRemoveBtn) {
      logoWhiteRemoveBtn.addEventListener('click', () => {
        this.clearFileInput('logo_white')
        document.getElementById('logo-white-preview').classList.add('hidden')
        document.getElementById('logo-white-dropzone').classList.remove('hidden')
        logoWhiteRemoveBtn.classList.add('hidden')
      })
    }
  }

  previewLogo(event) {
    const file = event.target.files[0]
    if (file) {
      this.previewImage(file, 'logo-image', 'logo-preview', 'logo-dropzone', 'logo-remove')
    }
  }

  previewLogoWhite(event) {
    const file = event.target.files[0]
    if (file) {
      this.previewImage(file, 'logo-white-image', 'logo-white-preview', 'logo-white-dropzone', 'logo-white-remove')
    }
  }

  previewImage(file, imageId, previewId, dropzoneId, removeButtonId) {
    // Check if it's an image file
    if (!file.type.match('image.*')) {
      alert('Please select an image file')
      return
    }

    // Create or get the image element
    let img = document.getElementById(imageId)
    if (!img) {
      img = document.createElement('img')
      img.id = imageId
      img.className = 'max-h-full max-w-full object-contain'
      document.getElementById(previewId).appendChild(img)
    }

    // Set up file reader
    const reader = new FileReader()
    reader.onload = (e) => {
      img.src = e.target.result
      document.getElementById(previewId).classList.remove('hidden')
      document.getElementById(dropzoneId).classList.add('hidden')
      document.getElementById(removeButtonId).classList.remove('hidden')
    }
    reader.readAsDataURL(file)
  }

  clearFileInput(inputName) {
    // Create a new input element to replace the existing one
    const input = document.querySelector(`input[name="account[${inputName}]"]`)
    if (input) {
      const newInput = document.createElement('input')
      newInput.type = 'file'
      newInput.name = input.name
      newInput.className = input.className
      newInput.id = input.id
      
      // Copy data attributes
      Array.from(input.attributes).forEach(attr => {
        if (attr.name.startsWith('data-')) {
          newInput.setAttribute(attr.name, attr.value)
        }
      })
      
      // Replace the input
      input.parentNode.replaceChild(newInput, input)
    }
  }

  highlight(event) {
    // Prevent default to allow drop
    event.preventDefault()
    
    // Add highlight class
    const target = event.currentTarget
    target.parentElement.classList.add('border-indigo-300', 'bg-indigo-50')
  }
  
  unhighlight(event) {
    // Remove highlight class
    const target = event.currentTarget
    target.parentElement.classList.remove('border-indigo-300', 'bg-indigo-50')
  }
  
  drop(event) {
    // Prevent default browser behavior
    event.preventDefault()
    
    // Remove highlight styling
    this.unhighlight(event)
    
    // Get the target input element
    const input = event.currentTarget
    
    // Get the dropped files
    const files = event.dataTransfer.files
    
    if (files.length > 0) {
      // Assign the dropped file to the input
      input.files = files
      
      // Trigger the change event to process the file
      const changeEvent = new Event('change', { bubbles: true })
      input.dispatchEvent(changeEvent)
    }
  }
}